import { useState } from "react";
import ProductList2 from "./ProductList2";
import ListShareMenu from "../components/ListShareMenu";
import InvitePeople from "./InvitePeople";
import { FaCheck, FaPen, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import { listNameExists } from "../lib/listNameExists";
import { saveShoppingListToAlgolia } from "../lib/algoliaFunctions";
import { getBaseURL } from "../lib/getBaseURL";
import { Link } from "react-router-dom";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import ShopListMore from "./ShopListMore";
import InvitedMembersList from "./InvitedMembersList";
const SingleChat = ({
  list,
  setActiveAccordion,
  isSmallScreen,
  shoppingListData,
  setShoppingListData,
  setLoading,
  type,
}) => {
  const baseURL = getBaseURL();
  const { user } = UserAuth();

  const BackgroundOnSvg = ({ children }) => (
    <div
      style={{
        width: "30px",
        height: "30px",
        borderRadius: "8px",
        backgroundColor: "#F1F4FF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
  return (
    <div
      className="d-flex flex-column shoppingList"
      style={{ padding: "6px 0px" }}
      key={list?.listId}
    >
      {/* Shopping List Header */}
      <div
        className={`d-flex justify-content-between align-items-center stickyHeader bg-mode`}
        style={{ padding: "10px 0px" }}
      >
        <div className="d-flex align-items-center">
          <div
            style={{
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setActiveAccordion([]);
            }}
          >
            <svg
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17 34L8 25L17 16"
                stroke="#667085"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>

          <div className="d-flex flex-column" style={{ gap: "4px" }}>
            <div
              title={list?.name}
              style={{
                fontFamily: "Inter",
                fontWeight: 600,
                fontSize: "24px",
                lineHeight: "112%",
                letterSpacing: "0%",
                color: "black",
              }}
            >
              {list?.name}
            </div>
            <InvitedMembersList
              listName={list?.name}
              userId={type === "myList" ? user?.uid : list?.userId}
              listId={list?.listId}
            />
          </div>
        </div>
        {isSmallScreen ? (
          <ul className="d-flex nav gap-2 align-items-center">
            <div onClick={(e) => e.stopPropagation()}>
              <InvitePeople
                selectedShopList={list}
                listId={list?.listId}
                listName={list?.name}
                myName={user?.displayName}
                listLink={`${baseURL}/#/shoppingList/${list?.listId}/${user?.uid}`}
              />
            </div>
            <div className="me-1" onClick={(e) => e.stopPropagation()}>
              <Link
                to={`/chat/${list?.listId}`}
                className="py-1 px-4 btn btn-outline-primary"
              >
                Chat
              </Link>
            </div>
            {type === "myList" && (
              <ShopListMore
                list={list}
                shoppingListData={shoppingListData}
                setShoppingListData={setShoppingListData}
                setLoading={setLoading}
                BackgroundOnSvg={BackgroundOnSvg}
                setActiveAccordion={setActiveAccordion}
                showShareButton={true}
              />
            )}
          </ul>
        ) : (
          <div
            className="d-flex p-0 align-items-center pe-2"
            style={{ gap: "8px" }}
          >
            {type === "myList" && (
              <div onClick={(e) => e.stopPropagation()}>
                <InvitePeople
                  selectedShopList={list}
                  listId={list?.listId}
                  listName={list?.name}
                  myName={user?.displayName}
                  listLink={`${baseURL}/#/shoppingList/${list?.listId}/${
                    type === "myList" ? user?.uid : list?.userId
                  }`}
                  componentName={"ShoppingList"}
                />
              </div>
            )}
            <div className="d-flex align-items-center">
              <div onClick={(e) => e.stopPropagation()}>
                <Link
                  to={`/chat/${list?.listId}`}
                  style={{
                    width: "40px",
                    height: "40px",
                  }}
                  className="d-flex align-items-center justify-content-end"
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.5833 2.74538C14.235 1.96543 12.6696 1.51904 11 1.51904C5.93737 1.51904 1.83331 5.6231 1.83331 10.6857C1.83331 12.1521 2.17763 13.538 2.78982 14.7672C2.95251 15.0938 3.00666 15.4671 2.91234 15.8196L2.36636 17.8602C2.12935 18.746 2.93974 19.5563 3.82555 19.3193L5.86609 18.7734C6.21858 18.679 6.59192 18.7332 6.91855 18.8958C8.14765 19.5081 9.53359 19.8524 11 19.8524C16.0625 19.8524 20.1666 15.7483 20.1666 10.6857C20.1666 9.01609 19.7202 7.45067 18.9403 6.10238"
                      stroke="#14191F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M7.33331 10.6855H7.34156M10.9917 10.6855H11M14.6584 10.6855H14.6666"
                      stroke="#14191F"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </Link>
              </div>
              <ShopListMore
                list={list}
                shoppingListData={shoppingListData}
                setShoppingListData={setShoppingListData}
                setLoading={setLoading}
                BackgroundOnSvg={BackgroundOnSvg}
                setActiveAccordion={setActiveAccordion}
                imageWidth="40px"
                svgWidth="22px"
                showShareButton={true}
                type={type}
              />
            </div>
          </div>
        )}
      </div>
      {/* Shopping List Body */}
      <div onClick={(e) => e.stopPropagation()}>
        {/* {shoppingListData?.length > 0 && <hr className="m-0 p-0" />} */}
        <ProductList2
          shoppingListData={shoppingListData}
          selectedShopListName={list?.name}
          selectedShopListId={list?.listId}
          userId={user?.uid}
          componentName={"ShoppingList"}
          ownerId={type === "myList" ? user?.uid : list?.userId}
          type={type}
        />
      </div>
    </div>
  );
};

export default SingleChat;
